/* eslint-disable @next/next/no-html-link-for-pages */
import React from 'react';

import { useCookie } from 'next-cookie';
import dynamic from 'next/dynamic';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import { validateAppAuth } from '../../redux/slices/authSlice/actions';
import { fetchContinueWatchingList } from '../../redux/slices/librarySlice';

// Components and Hooks
import styles from './UserLibrary.module.scss';

const LiveClassList = dynamic(() => import('./LiveClass/LiveClassList'));
const WatchList = dynamic(() => import('./WatchList'));

function UserLibrary() {
  const dispatch = useDispatch();
  // eslint-disable-next-line object-curly-newline
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  React.useEffect(() => {
    dispatch(fetchContinueWatchingList({}));
    if (typeof window !== 'undefined') {
      sessionStorage?.setItem('backButtonRoute', '/');
    }
  }, [dispatch]);

  const cookie = useCookie();
  const { newCourseConsumptionEnable, authUserDetails, authUser, storeEnable } = useSelector((state) => ({
    newCourseConsumptionEnable: state.auth?.authUser?.newCourseConsumptionEnable,
    authUserDetails: state.auth?.isAuthenticated,
    authUser: state.auth?.authUser,
    storeEnable: state.auth?.authUser?.storeEnable,
  }));

  React.useEffect(() => {
    if (newCourseConsumptionEnable === undefined || storeEnable === undefined) {
      const userID = cookie.get('userID');
      const apiToken = cookie.get('apiToken');

      if (userID && apiToken && authUserDetails && !authUser) {
        dispatch(
          validateAppAuth({
            userID,
            apiToken,
            forceLogin: false,
          }),
        );
      }
    }
  }, [newCourseConsumptionEnable]);

  if (!isAuthenticated) return null;

  return (
    <div className={styles.yourPurchasesWrapper}>
      <LiveClassList from="home" />

      <div className={styles.userLibraryContent}>
        <WatchList newCourseConsumptionEnable={newCourseConsumptionEnable} />
      </div>
    </div>
  );
}

export default UserLibrary;
